/**
 * Classes applied to the card of the node/trigger the user has clicked.
 *
 * The default `--ring` token in the v1 theme is a near-white warm tone
 * (`oklch(0.88 0.02 91.45)`), so a `ring-ring/50` halo is effectively invisible
 * against the canvas. Selection instead reads in the app's primary blue: a
 * solid border does the identifying work, and the soft 3px halo
 * (`0 0 0 3px oklch(0.398 0.0798 264.66 / 0.15)`, i.e. `--primary` at 15%)
 * lifts the card off the canvas without shouting.
 *
 * Both shells are driven from this one constant so nodes and triggers can't
 * drift apart again.
 */
export const WORKFLOW_SELECTED_CLASS =
  'border-primary ring-[3px] ring-primary/15';

/**
 * Fades the content of a trigger card whose trigger is switched off.
 *
 * Applied to the card's *contents* rather than the `Card` itself: `opacity`
 * multiplies through a subtree with no way for a child to opt back out, and
 * fading the on/off switch along with everything else makes it read as a dead
 * control rather than the way back on.
 */
export const WORKFLOW_DIMMED_CONTENT_CLASS = 'opacity-55 transition-opacity';
